// extracted by mini-css-extract-plugin
export default {"label":"checkboxComponent_label__9IoJL"};